/**
 * @generated SignedSource<<60628c910c6e7f5a4877d4231e1c7d17>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "accountid",
        "variableName": "accountId"
      }
    ],
    "concreteType": "GetDefaultCustomerInviteUser",
    "kind": "LinkedField",
    "name": "getdefaultcustomerinviteuser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "userid",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastname",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "firstname",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "previousinvitecount",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InviteCustomerButtonQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InviteCustomerButtonQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ec5b37450984f60cb140f80703e79034",
    "id": null,
    "metadata": {},
    "name": "InviteCustomerButtonQuery",
    "operationKind": "query",
    "text": "query InviteCustomerButtonQuery(\n  $accountId: UUID!\n) {\n  getdefaultcustomerinviteuser(accountid: $accountId) {\n    userid\n    lastname\n    firstname\n    email\n    previousinvitecount\n  }\n}\n"
  }
};
})();

node.hash = "b963dd39cdbfe7109aac5b68d42b87ef";

module.exports = node;
